export enum UnitType {
  Institution = 1,
  Department = 2,
  Program = 3,
  College = 4,
  School = 5,
  Other = 6,
  Administration = 20,
  Institute = 21,
  Division = 22,
  Hospital = 23,
  Laboratory = 24,
  Medical = 25,
}
